import { controls, currencyToNumber, grouped } from "../../controls";


const gl_statements = {
  label: "gl_statements",
  starting: true,
  url: "gl_statements",
  pageLabel: "gl_statements",
  pageType: "history",
  filter: [
...controls.displayText({ tab: "general", label: "Gl",star:false}),
...controls.oc({ tab: "general", c: "GL", placeHolder: "Gl Code", name: "gl_code",fastpath: "gls"}),
...controls.showData({ tab: "general", displaytype: "capital", data: "gl_display"}),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2 " }),


...controls.displayText({ tab: "filter", label: "From Date", star: true, width: "col-sm-2 " }), 
...controls.magicDate({ tab: "filter", isRequired: true, name: "from_date", width: "col-sm-2" }),


...controls.displayText({ tab: "filter", label: "To Date", star: true, width: "col-sm-2 " }),
...controls.magicDate({ tab: "filter", isRequired: true, name: "to_date", width: "col-sm-2" }),

  

   ...grouped.grouping('basic'),
   ...grouped.separation('advance'),
   ...grouped.comparative('advance'),
 

  ],
  form: [],
  history: {
    perPage: 10,
    reportHeader: "gl_statements",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },

    filterable:true,
    sortable: true,
    defaultsTo: 0,
    textReportProps: {
      '132': {
        filename: `gl_statements-$pageData.as_on_date$.oro`,
        empty:true,//true
        format: {},
        header: "default",
        footer: "default"
      }
    },
    reportProps: { searchable: true, sortable: true },
     displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
        width132: { size: 3 }//3
      },
      {
        Header: "date",
        accessor: "date",
      },
        {
        Header: "particulars",
        accessor: "particulars",
      },
      {
        Header: "Total Credit",
        accessor: "credit",
        type: "currency"  
      },
      {
        Header: "Total Debit",
        accessor: "debit",
         type: "currency",
    
      },

        {
            Header: "Total Balance",
            accessor: "all_total",
            width132: { size: 13, },
            formula: [{
              f: 'simpleArithmatic', calcType: 'sum', inputs: [{ source: 'row', field: 'credittilldate' },{ source: 'row', field: 'debittilldate' }

              ], resultVar: 'total'
            }],
            type: "currency",
          },  
    ]
  }
};

export default gl_statements;